import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const queryFn = ({ componentKey, componentId }: QueryParams) => {
    const url = `api/bo/narratives/getTemplateByKey`;
    const body: GetTemplateByKeyRequestBody = {
        componentKey,
        componentId,
        forCurrentCustomerOnly: true,
    };

    return network.post(url, body).then((response) => {
        return response.data;
    });
};

export const useQueryGetTemplateByKey = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getTemplateByKey', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.componentKey) && Boolean(params.componentId),
    });
};

interface QueryParams {
    componentKey: string | undefined;
    componentId: number | undefined | null;
}

type GetTemplateByKeyRequestBody = QueryParams & {
    forCurrentCustomerOnly: boolean;
};

export interface Placeholder {
    id: number;
    name: string;
    section: string;
    description: string;
}

interface QueryResponse {
    componentKey: string;
    id: number;
    placeholders: Placeholder[];
    text: string;
}
